var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticStyle:{"display":"none"}},[_c('div',{staticClass:"showDataLink",on:{"click":function($event){_vm.showData=!_vm.showData}}},[_vm._v(_vm._s(_vm.title ? _vm.title : 'showData'))]),(_vm.showData)?_c('pre',{staticClass:"code codeExtend"},[_vm._v(_vm._s(_vm.code))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }